'use client';

/*
 * Documentation:
 * Drawer — https://app.subframe.com/6fc7f5fbb098/library?component=Drawer_1e71b2cb-8d72-4e67-b368-8805179e9444
 */
import { c as _c } from "react/compiler-runtime";
import React from 'react';
import * as SubframeCore from '@subframe/core';
import * as SubframeUtils from '../utils';
interface ContentProps extends React.ComponentProps<typeof SubframeCore.Drawer.Content> {
  children?: React.ReactNode;
  className?: string;
}
const Content = React.forwardRef<HTMLDivElement, ContentProps>(function Content(t0, ref) {
  const $ = _c(9);
  let children;
  let className;
  let otherProps;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = otherProps;
  } else {
    children = $[1];
    className = $[2];
    otherProps = $[3];
  }
  let t1;
  if ($[4] !== children || $[5] !== className || $[6] !== otherProps || $[7] !== ref) {
    t1 = children ? <SubframeCore.Drawer.Content asChild={true} {...otherProps}><div className={SubframeUtils.twClassNames("bg-default-background drawer-content-transition flex h-full min-w-[320px] flex-col items-start gap-2 border-l border-solid border-neutral-200", className)} ref={ref}>{children}</div></SubframeCore.Drawer.Content> : null;
    $[4] = children;
    $[5] = className;
    $[6] = otherProps;
    $[7] = ref;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
});
interface DrawerRootProps extends React.ComponentProps<typeof SubframeCore.Drawer.Root> {
  children?: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  className?: string;
}
const DrawerRoot = React.forwardRef<HTMLDivElement, DrawerRootProps>(function DrawerRoot(t0, ref) {
  const $ = _c(9);
  let children;
  let className;
  let otherProps;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = otherProps;
  } else {
    children = $[1];
    className = $[2];
    otherProps = $[3];
  }
  let t1;
  if ($[4] !== children || $[5] !== className || $[6] !== otherProps || $[7] !== ref) {
    t1 = children ? <SubframeCore.Drawer.Root asChild={true} {...otherProps}><div className={SubframeUtils.twClassNames("drawer-overlay-transition z-50 flex h-full w-full flex-col items-end justify-center gap-2 bg-[#00000066]", className)} ref={ref}>{children}</div></SubframeCore.Drawer.Root> : null;
    $[4] = children;
    $[5] = className;
    $[6] = otherProps;
    $[7] = ref;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
});
export const Drawer = Object.assign(DrawerRoot, {
  Content
});